<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="emailTypes" formControlName="type" optionLabel="name" optionValue="value"
            placeholder="Select Email Type"></p-dropdown>
            <label for="Select Email Type">Select Email Type</label>
            @for (validation of validationMessages.type; track validation) {
              <span>
                @if (form1.get('type').hasError(validation.type) && (form1.get('type').dirty || form1.get('type').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="emailAdr" id="emailAdr" type="text" pInputText>
            <label for="emailAdr">Email Address</label>
            @for (validation of validationMessages.emailAdr; track validation) {
              <span>
                @if (form1.get('emailAdr').hasError(validation.type) && (form1.get('emailAdr').dirty || form1.get('emailAdr').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!--<div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="persons" formControlName="personId" appendTo="body" optionLabel="name"
            optionValue="personId" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Select Person">
          </p-dropdown>
          <label for="Select Person">Select Person</label>
          <span *ngFor="let validation of validationMessages.personId">
            <small class="p-invalid"
              *ngIf="form1.get('personId').hasError(validation.type) && (form1.get('personId').dirty || form1.get('personId').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div>-->
    </div>
  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (personEmailId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete Email</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
            @if (!personEmailId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add Email</button>
            }

            @if (personEmailId) {
              <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Email</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>